<footer>
  <div class="footer__info">
    <div class="about__lists">
      <ul class="about__list contact-info">
        <li class="font--special">
          <a href="mailto:yuriko.schumacher@gmail.com"
            ><i class="far fa-envelope"></i> yuriko.schumacher@gmail.com</a
          >
        </li>
        <li class="font--special">
          <a href="tel:6466680656"
            ><i class="fas fa-phone"></i> 646-668-0656</a
          >
        </li>
      </ul>
      <ul class="about__list">
        <li class="font--special">
          <a href="https://github.com/Yuriko-Schumacher/yuriko-schumacher.github.io/blob/main/public/pdf/resume.pdf" target="_blank">Resume</a>
        </li>
        <li>
          <a href="https://x.com/yuriko_a_s" target="_blank"
            ><i class="fa-brands fa-x-twitter"></i
          ></a>
        </li>
        <li>
          <a href="https://github.com/Yuriko-Schumacher" target="_blank"
            ><i class="fab fa-github"></i
          ></a>
        </li>
        <li>
          <a
            href="https://www.linkedin.com/in/yuriko-schumacher/?locale=en_US"
            target="_blank"
            ><i class="fab fa-linkedin"></i
          ></a>
        </li>
      </ul>
    </div>
  </div>
  <div class="credit">
    <p class="font--special">© Yuriko Schumacher 2025</p>
  </div>
</footer>

<style>
  .about__lists {
    margin-top: 1.5rem;
  }
  .about__list{
    padding: 0;
    display: flex;
    align-items: flex-end;
    font-family: var(--font-serif);
    font-style: italic;
    gap: 1rem;
    font-size: 0.8em;
  }
  .about__list > li {
    list-style: none;
  }
</style>